import React, { useEffect, useState } from 'react';
import Loader from '@components/Loader';

import './PlaybackPreparingLoader.less';

// Loads finishing faster than this show no loader, so switching quickly
// between media does not flash it
export const DELAYED_LOADER_MS = 300;

function PlaybackPreparingLoader({
  isVideo,
  delayed = false
}: {
  isVideo?: boolean;
  /** Show only if still mounted after a short delay (plain loading states) */
  delayed?: boolean;
}) {
  const [isVisible, setIsVisible] = useState(!delayed);

  useEffect(() => {
    if (!delayed) return;
    const timeout = setTimeout(() => setIsVisible(true), DELAYED_LOADER_MS);
    return () => clearTimeout(timeout);
  }, [delayed]);

  if (!isVisible) return null;

  return (
    <div className="media_viewer_playback_container">
      <div className="media_viewer_playback_container__content">
        <Loader spinSize={72} isSpinning={true} classNameWrapper="loader" />
        <div className="copy">
          {isVideo ? 'Preparing for playback...' : 'Preparing preview...'}
        </div>
      </div>
    </div>
  );
}

export default PlaybackPreparingLoader;
